<app-alert-notification id="alert-bar"></app-alert-notification>

<div style="display: flex; flex-direction: column">
  <app-nav></app-nav>

  <div [ngStyle]="{'max-width': isFileOnline ? '1800px' : '#inherit'}" class="container">
    <div id="QA Alert" *ngIf="showingQABanner" class="efile-disabled">
      <h3 style="color: black; text-align: center">FOR INTERNAL USE ONLY</h3>
      <h3 style="color: black; text-align: center">ANY SUBMISSION WILL NOT BE PROCESSED</h3>
      <p style="color: black; margin-bottom: 0; text-align: center"><b>This site is intended for quality assurance testing. Click to visit <a href="https://assessor.lacounty.gov">The Official Assessor Website</a></b>.</p>
      <!--    <button class="btn" style="width: 200px" (click)="onDismissBanner()">Click to dismiss</button>-->
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>

  <app-footer class="page-footer"></app-footer>
</div>


<app-newsletter-popup></app-newsletter-popup>
<button #slideInButton  (mouseenter)="onMouseEnter()" (mouseleave)="onMouseOut()" (click)="chatService.openChatBot()" class="expand-button slide-in-button fade-button pulse-button typing-button"><i style="" class="fas fa-comment-dots px-2"></i> <strong>{{typingText}}</strong></button>
<app-chatbot></app-chatbot>


